function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

const SvgIconDrawerEmpty = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15.517,
    viewBox: "0 0 24 15.517",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M26.038,18.4l-2.887-7a.837.837,0,0,0-.773-.532H6.019a.839.839,0,0,0-.773.531l-2.886,7a6.426,6.426,0,0,0-.167,1.233v4.5a2.253,2.253,0,0,0,2.25,2.25h19.5a2.253,2.253,0,0,0,2.25-2.25v-4.5A6.652,6.652,0,0,0,26.038,18.4ZM6.576,12.61H21.823l1.967,4.769H19.361a.75.75,0,0,0-.652.378,5.2,5.2,0,0,1-9.033,0,.749.749,0,0,0-.651-.378H4.61ZM24.693,24.129a.752.752,0,0,1-.75.75H4.443a.751.751,0,0,1-.75-.75v-4.5a.724.724,0,0,1,.077-.318c.008-.01.014-.023.022-.033a.742.742,0,0,1,.651-.4H8.606a6.7,6.7,0,0,0,11.174,0h4.163a.751.751,0,0,1,.75.75Z",
    transform: "translate(-2.193 -10.862)",
    style: {}
  }));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDrawerEmpty, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-drawer-empty.2c14090c.svg";
export { ForwardRef as ReactComponent };